import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./Utils/config.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";

import "antd/dist/antd.css";

window.$url = "https://api-v3.deceyec.mx/api/";
//window.$url = 'http://127.0.0.1:8000/api/';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
